import React from 'react';

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  size?: number;
};

const WandIcon: React.FC<Props> = ({ size = 18, className, style, ...rest }) => {
  return (
    <span
      aria-hidden
      {...rest}
      className={`anticon${className ? ` ${className}` : ''}`}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        backgroundColor: 'currentColor',
        WebkitMaskImage: 'url(/images/icons/Wand.svg)',
        maskImage: 'url(/images/icons/Wand.svg)',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        ...style,
      }}
    />
  );
};

export default WandIcon;
